import user from '../store/modules/user'

import { PERMISSIONS } from '@/utils/enum'

export function hasPermission(menus, route) {
  if (route.noAuth) {
    console.log('此菜单ok', route)
    return true
  }
  for (let i = 0; i < menus.length; i++) {
    if (menus[i] === route.name) {
      return true
    }
  }
  return false
}

export function hasActionPermission(code) {
  return user.state.permissions && user.state.permissions.indexOf(code) !== -1
}

export function getMenu(isSoftManager = false) {
  if (isSoftManager) {
    return ['softwareManage', 'softwareList', 'softwareDictionary']
  } else {
    return [
      'webManage',
      'articleManage',
      'arcticle',
      'addArticle',
      'setting',
      'indexSetting',
      'innerPageSetting',
      'fileManage',
      'file',
      'dataAnalysis',
      'contentAnalysis',
      'fileAnalysis',
      'softwareManage',
      'softwareList',
      'softwareDictionary',
      'functionAnalysis',
      'whitelistManage',
      'whitelist',
      'whitelistDetail',
      'activeOrganization',
      'activeOrganizationList',
      'activeOrganizationDetail',
      'activeOrganizationBehaviorDetail',
      'terminalBehaviorDetail',
      'behaviorTerminalDetail',
      'firstLoginBehaviorDetail',
      'characteristicOrganization',
      'BulletinBoard',
      'decentralizedOrgList'
    ]
  }
}

export function isSoftManager(permissions = []) {
  return permissions.length > 0 && permissions.indexOf(PERMISSIONS.SOFTWARE_MANAGER) > -1
}

// 获取登录之后跳转路劲
export function getPath(isSoftManager) {
  return isSoftManager ? '/software-manage/software-list' : '/web-manage/article-manage/article'
}
